export const APP_VERSION =
  process.env.DOPPLER_PUBLIC_APP_VERSION ??
  process.env.NEXT_PUBLIC_VERSION ??
  process.env.REACT_APP_VERSION ??
  process.env.VITE_PUBLIC_VERSION ??
  process.env.APP_VERSION ??
  "0.0.0";
